"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStringCased = getStringCased;
var _changeCase = require("change-case");
var _utils = require("./utils");
function getStringCased(_ref) {
  var input = _ref.input,
    _ref$newLine = _ref.newLine,
    newLine = _ref$newLine === void 0 ? "yes" : _ref$newLine,
    _ref$casing = _ref.casing,
    casing = _ref$casing === void 0 ? "camelCase" : _ref$casing;
  if (newLine === "yes") {
    return (0, _utils.splitInputByLinesAndApplyCallBack)(input, function (arg) {
      return translateSentence(casing, arg);
    });
  }
  return translateSentence(casing, input);
}
function translateSentence(casing, input) {
  switch (casing) {
    case "camelcase":
      return (0, _changeCase.camelCase)(input);
    case "capitalcase":
      return (0, _changeCase.capitalCase)(input);
    case "constantcase":
      return (0, _changeCase.constantCase)(input);
    case "dotcase":
      return (0, _changeCase.dotCase)(input);
    case "kebabcase":
      return (0, _changeCase.kebabCase)(input);
    case "nocase":
      return (0, _changeCase.noCase)(input);
    case "pascalcase":
      return (0, _changeCase.pascalCase)(input);
    case "pascalsnakecase":
      return (0, _changeCase.pascalSnakeCase)(input);
    case "pathcase":
      return (0, _changeCase.pathCase)(input);
    case "sentencecase":
      return (0, _changeCase.sentenceCase)(input);
    case "snakecase":
      return (0, _changeCase.snakeCase)(input);
    case "headercase":
      return (0, _changeCase.trainCase)(input);
    case "uppercase":
      return input.toUpperCase();
    case "lowercase":
      return input.toLowerCase();
    default:
      return (0, _changeCase.camelCase)(input);
  }
}